import { Resource } from "../resource"

export class Priority extends Resource{
    name: string | any
} 